import "./Overlay.scss";
import React, { useState, useEffect } from "react";
import { AiFillCamera } from "react-icons/ai";
// import { BsDropletHalf, BsDropletFill } from "react-icons/bs";
import { useSnapshot } from "valtio";
import { state, materialsAlaM } from "./store";

const useCheckMobile = () => {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const _isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        window.navigator.userAgent
      );
    console.log(`check device type: ${_isMobile ? "mobile" : "desktop"}`);
    setIsMobile(_isMobile);
  }, []);
  return isMobile;
};

export const Customizer2 = ({ handleDownload }) => {
  const snap = useSnapshot(state);
  const isMobile = useCheckMobile();

  if (snap.focusDetail || snap.beforeExitFocus) {
    return (
      <>
        <div
          className={`panel_info${snap.beforeExitFocus ? " close" : " open"}`}
        >
          {state.infopoint.description}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="color-options">
        {materialsAlaM.map(
          (material, index) => (
            <div
              key={index}
              style={{
                background:
                  snap.color === material.preview
                    ? `${material.preview}`
                    : `linear-gradient(0deg, ${material.preview}, ${material.preview}, transparent)`,
              }}
              className="circle"
              onClick={() => {
                state.texture = material.texture;
                state.color = material.preview;
              }}
            />
          )
          // {
          //   if (snap.color === material.preview) {
          //     return (
          //       <BsDropletFill
          //         key={index}
          //         color={material.preview}
          //         className="icon"
          //         onClick={() => {
          //           state.texture = material.texture;
          //           state.color = material.preview;
          //         }}
          //       />
          //     );
          //   }
          //   return (
          //     <BsDropletHalf
          //       key={index}
          //       color={material.preview}
          //       className="icon"
          //       onClick={() => {
          //         state.texture = material.texture;
          //         state.color = material.preview;
          //       }}
          //     />
          //   );
          // }
        )}
      </div>
      <button
        style={{
          position: "absolute",
          top: "40px",
          right: "40px",
          background: snap.color,
        }}
        onClick={handleDownload}
      >
        DOWNLOAD
        <AiFillCamera size="1.3em" />
      </button>

      <div className="button_container">
        <button
          style={{
            background: snap.color,
          }}
        >
          <a href={isMobile ? "mailto:info@alam.it" : `mailto:info@alam.it`}>
            CONTACT US
          </a>
        </button>
        <button
          style={{
            background: snap.color,
          }}
          onClick={() => {
            window.open("http://afhjn-trafficmgr-mm.trafficmanager.net");
          }}
        >
          <p>PLAY</p>
        </button>

        <button
          style={{
            background: snap.color,
          }}
          onClick={() => {
            window.open("https://opensea.io/collection/ala-m");
          }}
        >
          <p>BUY NFT</p>
        </button>

        <button
          style={{
            background: snap.color,
          }}
          onClick={() => {
            state.showVideo = true;
          }}
        >
          <p>TRY IN VR</p>
        </button>
      </div>
      <div className="top_logo">
        <img src="logo.png" alt="" />
      </div>
    </>
  );
};
